module.exports = __webpack_public_path__ + "img/KM-360A_11.a45ac702.jpg";